import { render, staticRenderFns } from "./Branch-offices.vue?vue&type=template&id=6684ce58"
import script from "./Branch-offices.vue?vue&type=script&lang=js"
export * from "./Branch-offices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports